import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';

export enum ProductLevel {
  Level1 = 'Level1',
  Level2 = 'Level2',
  Level3 = 'Level3',
  SmartTag = 'SmartTag'
}

export interface BannerImageConfig {
  level: string;
  planBannerImageSrc: string;
  objectPosition: string;
}

@Component({
  selector: 'app-product-hero',
  templateUrl: './product-hero.component.html',
  styleUrls: ['./product-hero.component.scss'],
})
export class ProductHeroComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() secondarySubtitle: string;

  @Input() level: ProductLevel;
  @Input() badgeUri: string;
  @Input() compareVisible: boolean;
  @Input() buyHidden: boolean;
  @Input() levelsVisible: boolean;
  @Input() buyButtonText: string;
  @Input() disabled: boolean;

  @Output() onBuyClick: EventEmitter<string> = new EventEmitter();
  @Output() onCompareClick: EventEmitter<string> = new EventEmitter();

  public productLevel = ProductLevel;
  public plan1Route: string;
  public plan2Route: string;
  private bannerImageConfig: BannerImageConfig[];
  public bannerImage: BannerImageConfig;

  buy(): void {
    this.onBuyClick.emit();
  }

  compare(): void {
    this.onCompareClick.emit();
  }

  constructor(private configService: ConfigService) {
    this.plan1Route = this.configService.getTextFromKey('1-plan-route');
    this.plan2Route = this.configService.getTextFromKey('2-plan-route');
    this.bannerImageConfig = this.configService.get('productBanners');
  }

  ngOnInit(): void {
    this.bannerImage = this.bannerImageConfig.find(
      banner => banner.level === this.level
    );
  }
}
